/* mm-rev: 2026-09-24-SE-4 */
/*
 * BEAUTY CLUB-POPUP (oppdatert 18.09.2026)
 *
 * Modish-popupen (assets/modish-popup.js, lastes i layout/theme.liquid) vises ved
 * sidevisning. Denne filen lastes rett etter modish-popup.js, men før
 * DOMContentLoaded. Settes MM_DISABLE_BEAUTY_CLUB_POPUP til true, fjernes
 * #custom_popup her, popup-skriptet finner ingen plass å tegne popupen i, og den
 * vises ikke.
 *
 * Står nå på false, altså popupen er PÅ. Sett til true for å slå den av igjen.
 */
var MM_DISABLE_BEAUTY_CLUB_POPUP = false;

try {
  if (MM_DISABLE_BEAUTY_CLUB_POPUP) {
    var mmBeautyClubPopupContainer = document.getElementById('custom_popup');
    if (mmBeautyClubPopupContainer) {
      mmBeautyClubPopupContainer.remove();
    }
  }
} catch (error) {
  console.error('Beauty Club-popup:', error);
}

/*
 * PRODUKTSIDE-STILENE (mm-product-page.css og mm-badges.css)
 *
 * 24.09.2026 (Claude): Blokken som la disse inn med JavaScript (mmEnsureStylesheets) er FJERNET.
 * Stilene lastes nå direkte i <head> i layout/theme.liquid, rett etter theme.css, og gjelder
 * fortsatt alle sider og alle produktmaler. Lagt inn med JavaScript kom CSS-en først etter at siden
 * var tegnet: ikonene i USP-raden ble tegnet i full bredde (stort pakke-ikon som blinket), og
 * pris/avstander hoppet. Sammenligningen av lenker her feilet dessuten (asset_url er //-relativ,
 * link.href er https://), så lenkene ville blitt lagt inn to ganger.
 */

/*
 * BONUS-MERKET PÅ SAMME LINJE SOM PRODUKTMERKET (18.09.2026)
 *
 * «Tjäna X % i bonus» (Modish) rendres øverst i produktinfoen, på sin egen linje over
 * merkene. Beholderne flyttes her inn i merkeraden, slik at bonus-merket står ved siden av
 * bestselger-merket i stedet for over det.
 *
 * Kjører før DOMContentLoaded (defer), altså før assets/modish-bonus-tag.js fyller beholderen.
 * Det skriptet finner beholderen på id, så flyttingen påvirker ikke innmatingen.
 * Finnes det ingen merkerad på siden, blir bonus-merket stående der det er.
 *
 * try/catch: alt under i denne filen (blant annet Lipscore-initieringen) skal kjøre selv om
 * noe her feiler.
 *
 * Marger og skjuling av tomme beholdere: se assets/mm-badges.css.
 */
try {
  (function mmMoveBonusTagIntoBadgeRow() {
    var badgeList = document.querySelector('.product-info__block-item[data-block-type="badges"] badge-list');

    if (!badgeList) return;

    badgeList.style.display = 'flex';
    badgeList.style.flexWrap = 'wrap';
    badgeList.style.alignItems = 'center';

    ['bonus-tag-for-all', 'bonus-tag-for-sale', 'bonus-tag-for-original'].forEach(function (id) {
      var container = document.getElementById(id);

      if (!container) return;

      container.style.display = 'inline-flex';
      container.style.alignItems = 'center';
      badgeList.appendChild(container);
    });
  })();
} catch (error) {
  console.error('Bonus-merke i merkerad:', error);
}

/*
 * STICKY KJØPSLINJE UNDER KAMPANJELINJEN (18.09.2026)
 *
 * Måler høyden på kampanjelinjen og legger den i --mm-announcement-offset, som regelen for
 * .product-sticky-bar i assets/mm-product-page.css bruker som luft på toppen. Bare når linjen er
 * position: fixed («Vis kun når man har scrollet»); ellers 0, siden temaet da allerede har regnet den
 * inn i --sticky-area-height.
 */
try {
  (function mmAnnouncementOffset() {
    function sync() {
      try {
        var bar = document.querySelector('.shopify-section--announcement-bar');
        var offset = 0;

        if (bar && window.getComputedStyle(bar).position === 'fixed') {
          offset = bar.getBoundingClientRect().height || 0;
        }

        document.documentElement.style.setProperty('--mm-announcement-offset', offset.toFixed(2) + 'px');
      } catch (error) {}
    }

    sync();

    document.addEventListener('DOMContentLoaded', sync);
    window.addEventListener('load', sync);
    window.addEventListener('resize', sync, { passive: true });
    document.addEventListener('shopify:section:load', sync);
  })();
} catch (error) {
  console.error('Kampanjelinje-offset:', error);
}

/*
 * Lipscore widget refresh for theme-editor section reloads.
 * Dynamic grids (filters, Hello Retail) are handled in assets/lipscore-cards.js.
 */
function mmInitLipscoreWidgets() {
  if (window.lipscore && typeof window.lipscore.initWidgets === 'function') {
    window.lipscore.initWidgets();
  }
}

window.mmInitLipscoreWidgets = mmInitLipscoreWidgets;

document.addEventListener('shopify:section:load', mmInitLipscoreWidgets);

if (window.location.href.includes("/loyalty")) {
  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get("email");

  if (email) {
    console.log("Email:", email);

    const emailInput = document.getElementById("email");
    if (emailInput) {
      emailInput.value = email;
    }
  } else {
    console.log("Email parameter not found in the URL.");
  }
}